import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=6725db5f&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=6725db5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725db5f",
  null
  
)

export default component.exports